import { gql } from '@apollo/client';
import { Client } from '../../fragments/client/client.fragments';

const FIND_MY_COMMANDE = gql`
    query FindMyCommande($id: ID!,$numerocommande:String!, $classeId: ID!) {
        findMyCommande(id: $id,numerocommande:$numerocommande, classeId: $classeId) {
            commande {
                id
                createdAt
                numerocommande
                totalttc
                fraislivraison
                prixTotal
                customerContributedToTheOng
                methodepaiement
                payment
                transactionreference
                statuspayment
                status
                client {
                    ...ClientResult
                }
                commandelines {
                    id
                    quantite
                    produit {
                        id
                        name
                        ttcPrice
                        ref
                        venterebond
                        media {
                            url
                        }
                    }
                }
                user {
                    firstname
                    lastname
                    email
                    classe {
                        debut
                        fin
                        operationid
                        filliere {
                            name
                        }
                        lycee {
                            name
                            academie {
                                name
                            }
                        }
                        niveau {
                            name
                        }
                    }
                }
            }
            sherlock{
                data
                interfaceVersion
                redirectionUrl
                seal
            }
        }
    }
    ${Client.fragments.clientResult},
`;

export default FIND_MY_COMMANDE;
